import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { OrganizationMemberLabel } from "@components/organizationView/shared/OrganizationMemberLabel";
import { MemberAccessLogRow } from "../memberAccessLogRow";

export const MemberCell = memo(
    ({ row }: CellContext<ViewTableFeatures, MemberAccessLogRow, unknown>) => (
        <OrganizationMemberLabel userId={row.original.userId} />
    ),
);
